export const USER_SETTINGS_ENDPOINT = `/foundation_v1/me/settings`

export const DEFAULT_HOMEPAGE_OPTION = { name: "Default", path: "/home" }

export const AVAILABLE_HOMEPAGE_OPTIONS = ["/srb", "/wiki"]
